export class ToastAdapter {
    constructor({ Toast }) {
        this.Toast = Toast;
    }

    /**
     * @public
     *
     * @param {Object} param { position: string,  message: string }
     *
     * @exemples
     * position : [top right]
     *
     * @void
     */
    show({ position, message } = {}) {
        position = position ? position : "top right";

        this.Toast.show(
            this.Toast.simple({
                content: message,
                position: position
            })
        );
    }
}
